import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React, {
  useMemo,
  useState,
  useEffect,
}                               from 'react';
import { createRoot }           from 'react-dom/client';
import Register                 from './screens/Register';
import Home                     from './screens/Home';
import MFA                      from './screens/MFA';
import ResetPassword            from './screens/ResetPassword';
import ResetPasswordRequest     from './screens/ResetPasswordRequest';
import {
  UserAgentContext,
  getUserAgentData,
  useUserAgent,
}                           from 'hooks/useUserAgent';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
  useLocation,
}                               from 'react-router-dom';
import {
  IntlProvider,
  FormattedMessage,
}                               from 'react-intl';
import { match as matchLocale } from '@formatjs/intl-localematcher';
import locales                  from './locales.json';

import '../shared/index.css';

const AutoLogin = () => {
  const location = useLocation();
  const { is_mobile } = useUserAgent();
  useEffect(() => {
    const search = new URLSearchParams(location.search);
    if (search.get('decoded_token')) {
      localStorage.clear();
      localStorage.setItem('decoded_token', decodeURIComponent(search.get('decoded_token')));
      window.location.replace(is_mobile ? '/mobile' : '/crm');
    }
  }, [ location, is_mobile ]);

  return (
    <div>
      <FormattedMessage defaultMessage="Entrando en la cuenta..."/>
    </div>
  );
};

const desired_locale = navigator.language || 'es';
const available_locales = locales.map(l => l.key);
const match_lang = matchLocale([desired_locale], available_locales, 'en-US');

const App = () => {
  const [ messages, setMessages ] = useState({});
  const loadLocale = loc => fetch(`/compiled-langs/${loc}`)
    .then(r => r.ok && r.json() || Promise.reject('Error while loading locale'))
    .then(messages => setMessages(m => ({ ...m, [loc]: messages })))
    .catch(console.error);
  const user_agent_data = useMemo(() => getUserAgentData(), []);

  useEffect(() => { loadLocale(match_lang) }, []);

  return (
    <IntlProvider
      defaultLocale={match_lang}
      locale={match_lang}
      messages={messages[match_lang]}
      onError={() => {}}
      defaultRichTextElements={{
        b: text => <b>{text}</b>,
        i: text => <i>{text}</i>,
        u: text => <u>{text}</u>,
        ul: text => <ul>{text}</ul>,
        li: text => <li>{text}</li>,
        br: () => <br />,
        span: text => <span>{text}</span>,
      }}
    >
      <UserAgentContext.Provider value={user_agent_data}>
        <Router>
          <main
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              height: '100%',
              gap: '1em',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Switch>
              <Route path='/unauthenticated/register*' component={Register} />
              <Route path='/unauthenticated/home*' component={Home} />
              <Route path='/unauthenticated/mfa*' component={MFA} />
              <Route path='/unauthenticated/reset-password-request*' component={ResetPasswordRequest} />
              <Route path='/unauthenticated/reset-password*' component={ResetPassword} />
              <Route path='/autologin*' component={AutoLogin} />
              <Route exact path='/unauthenticated'>
                <Redirect to='/unauthenticated/home' />
              </Route>
              <Route path='/mfa.html'>
                <Redirect to={'/unauthenticated/mfa'.concat(window.location.search)} />
              </Route>
              <Route path='*'>
                <Redirect to='/unauthenticated/home' />
              </Route>
            </Switch>
          </main>
        </Router>
      </UserAgentContext.Provider>
    </IntlProvider>
  );
};

const root = createRoot(document.getElementById('root'));

root.render(<App />);
